import React from "react";
import { WishListListBody } from "tsi-common-react/src/apps/customer-account/WishListListBody/index";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.WishListListDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <WishListListBody {...props} />
    </PageSkeleton>
);
